<template>
  <div class="time-warp">
    <!-- <el-radio-group v-model="position">
      <el-radio-button :label="item.type"
                       v-for="(item,index) in control.data"
                       :key="index">{{item.label}}</el-radio-button>
    </el-radio-group>-->

    <div v-show="showType">
      <label>时间类型：</label>
      <el-select v-model="position" style="width: 80px">
        <el-option
          :label="item.label"
          :value="item.type"
          v-for="(item, index) in control.data"
          :key="index"
        ></el-option>
      </el-select>
    </div>

    <div class="item">
      <div v-if="position == 'day'">
        <el-date-picker
          style="width: 150px"
          v-model="day"
          :picker-options="pickerOptions"
          type="date"
          :key="new Date().getTime()"
          :clearable="false"
          placeholder="选择日期"
        ></el-date-picker>
      </div>
      <div v-if="position == 'week'">
        <el-date-picker
          type="week"
          style="width: 150px"
          v-model="week"
          :picker-options="pickerOptionsWeek"
          :key="new Date().getTime()"
          format="yyyy 第 WW 周"
          :clearable="false"
          placeholder="选择周"
        ></el-date-picker>
      </div>
      <div v-if="position == 'month'">
        <el-date-picker
          style="width: 150px"
          type="month"
          :picker-options="pickerOptionsMonth"
          v-model="month"
          :key="new Date().getTime()"
          placeholder="选择月"
          :clearable="false"
        ></el-date-picker>
      </div>
      <div v-if="position == 'year'">
        <el-date-picker
          style="width: 150px"
          type="year"
          :picker-options="pickerOptions"
          v-model="year"
          :key="new Date().getTime()"
          :clearable="false"
          placeholder="选择年"
        ></el-date-picker>
      </div>
      <div v-if="position == 'timeInterval'">
        <el-date-picker
          type="datetimerange"
          v-model="timeInterval"
          :picker-options="pickerOptions"
          :key="new Date().getTime()"
          :editable="false"
          :clearable="false"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        ></el-date-picker>
      </div>
      <div v-if="position == 'years'">
        <el-date-picker
          style="width: 150px"
          type="year"
          :picker-options="pickerOptionsYear"
          :key="new Date().getTime()"
          v-model="years"
          :clearable="false"
          placeholder="选择年"
        ></el-date-picker>
      </div>
    </div>
    <slot></slot>
    <div class="item">
      <el-button
        style="height: 30px; line-height: 0px"
        type="primary"
        class="primary"
        @click="bindQuery"
        >查询</el-button
      >
      <el-button
        style="height: 30px; line-height: 0px"
        type="primary"
        class="btn"
        @click="exportExc"
        v-if="showExportBtn == true"
        >导出</el-button
      >
      <el-button
        style="height: 30px; line-height: 0px"
        type="primary"
        class="btn"
        v-if="showPrint == true"
        @click="bindPrint"
        >打印</el-button
      >
      <!-- v-print="showPrintId" -->
      <!-- v-print="'#printTest'" -->
    </div>
    <div class="item" v-if="showOperation">
      <el-button
        style="height: 30px; line-height: 0px"
        type="primary"
        class="btn"
        @click="operationTree(true)"
        >全部展开</el-button
      >
      <el-button
        style="height: 30px; line-height: 0px"
        type="primary"
        class="btn"
        @click="operationTree(false)"
        >全部折叠</el-button
      >
    </div>
  </div>
</template>

<script>
import DateTool from "@/utils/dateTool.js";

export default {
  props: {
    control: {
      type: Object,
      default: () => ({
        data: [],
      }),
    },
    showExportBtn: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    showPrint: {
      type: Boolean,
      default: false,
    },
    showPrintId: {
      type: String,
      default: "",
    },
    showPrintTitle: {
      type: String,
      default: "",
    },
    showOperation: {
      type: Boolean,
      default: false,
    },
    pickerOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pickerOptionsWeek: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pickerOptionsMonth: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pickerOptionsYear: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      position: "",
      startTime: null,
      endTime: null,
      day: new Date(),
      week: new Date(),
      month: new Date(),
      year: new Date(),
      timeInterval: [
        new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        new Date(),
      ],
      years: new Date(),
      name: "",
      clicked: false,
      arr: [
        {
          name: "张三",
        },
      ],
    };
  },
  watch: {
    position(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeControlChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    day(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    week(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    month(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    year(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    timeInterval(newVal, oldVal) {
      let vm = this;
      vm.calcTime();
      newVal !== oldVal &&
        vm.$emit("timeChange", {
          dateType: vm.position,
          startTime: vm.startTime,
          endTime: vm.endTime,
        });
    },
    showPrintTitle(newVal, oldVal) {
      this.name = newVal;
    },
    // "control.data"(newVal, oldVal) {
    //   let vm = this;
    //   if (vm.control.data.length > 0) {
    //     if (!vm.clicked) {
    //       vm.position = vm.control.data[0].type;
    //     }
    //   }
    // },
  },
  mounted() {
    let vm = this;
    if (vm.control.data.length > 0) {
      vm.position = vm.control.data[0].type;
    }
    // this.bindQuery()
  },
  methods: {
    /* 第一次赋值potion */
    initTime() {
      vm.$emit("initTime", {
        dateType: vm.position,
        startTime: vm.startTime,
        endTime: vm.endTime,
      });
    },
    calcTime() {
      let vm = this;
      let startTime = DateTool.format(new Date(), "yyyy-MM-dd") + " 00:00:00";
      let endTime = DateTool.format(new Date(), "yyyy-MM-dd") + " 00:00:00";
      if (vm.position == "day") {
        startTime = DateTool.format(vm.day, "yyyy-MM-dd") + " 00:00:00";
        let end = new Date(vm.day);
        end.setDate(vm.day.getDate() + 1);
        endTime = DateTool.format(end, "yyyy-MM-dd") + " 00:00:00";
      } else if (vm.position == "week") {
        startTime = DateTool.format(vm.week, "yyyy-MM-dd") + " 00:00:00";
        let end = new Date(vm.week);
        end.setDate(vm.week.getDate() + 6);
        endTime = DateTool.format(end, "yyyy-MM-dd") + " 00:00:00";
      } else if (vm.position == "month") {
        startTime = DateTool.format(vm.month, "yyyy-MM") + "/01 00:00:00";
        let end = new Date(vm.month);
        end.setMonth(vm.month.getMonth() + 1);
        endTime = DateTool.format(end, "yyyy-MM") + "/01 00:00:00";
      } else if (vm.position == "year") {
        startTime = DateTool.format(vm.year, "yyyy") + "/01/01 00:00:00";
        let end = new Date(vm.year);
        end.setFullYear(vm.year.getFullYear() + 1);
        endTime = DateTool.format(end, "yyyy") + "/01/01 00:00:00";
      } else if (vm.position == "years") {
        let time1 = vm.years;
        startTime = [];
        endTime = [];

        for (let i = 0; i < 5; i++) {
          startTime.push(
            DateTool.format(
              new Date(new Date(time1).setFullYear(time1.getFullYear() - i)),
              "yyyy"
            ) + "/01/01 00:00:00"
          );
          endTime.push(
            DateTool.format(
              new Date(
                new Date(time1).setFullYear(time1.getFullYear() - i + 1)
              ),
              "yyyy"
            ) + "/01/01 00:00:00"
          );
        }
        startTime.reverse();
        endTime.reverse();
      } else {
        startTime = DateTool.format(vm.timeInterval[0], "yyyy-MM-dd hh:mm:ss");
        endTime = DateTool.format(vm.timeInterval[1], "yyyy-MM-dd hh:mm:ss");
      }
      vm.startTime = startTime;
      vm.endTime = endTime;
    },
    bindQuery() {
      let vm = this;
      vm.calcTime();
      vm.clicked = true;
      vm.$emit("timeControlClick", {
        dateType: vm.position,
        startTime: vm.startTime,
        endTime: vm.endTime,
      });
    },
    setSelectedFrist() {
      if (this.control.data.length > 0) {
        this.position = this.control.data[0].type;
      }
    },
    exportExc() {
      //点击导出模板
      this.$emit("exportExc");
    },
    //打印模板
    bindPrint() {
      let vm = this;
      this.name = this.showPrintTitle;
      if (vm.position == "day") {
        vm.name += DateTool.format(new Date(vm.startTime), "yyyy年MM月dd日");
      } else if (vm.position == "month") {
        vm.name += DateTool.format(new Date(vm.startTime), "yyyy年MM月");
      } else {
        vm.name += DateTool.format(new Date(vm.startTime), "yyyy年");
      }
      this.$print.print_dom_id(this.showPrintId, vm.name);
    },
    operationTree(flag) {
      //展开与折叠
      this.$emit("operationTree", flag);
    },
    prev() {
      this.setDateComTime(-1);
    },
    next() {
      this.setDateComTime(1);
    },
    /**
     * 设置控件时间   num  正数为往下，负数为往前
     */
    setDateComTime(num) {
      let vm = this;
      if (vm.position == "day") {
        let date = new Date(vm.day).setDate(new Date(vm.day).getDate() + num);
        vm.day = new Date(date);
        vm.bindQuery();
      } else if (vm.position == "week") {
        let date = new Date(vm.week).setDate(
          new Date(vm.week).getDate() + num * 7
        );
        vm.week = new Date(date);
        vm.bindQuery();
      } else if (vm.position == "month") {
        let date = new Date(vm.month).setMonth(
          new Date(vm.month).getMonth() + num
        );
        vm.month = new Date(date);
        vm.bindQuery();
      } else if (vm.position == "year") {
        let date = new Date(vm.year).setFullYear(
          new Date(vm.year).getFullYear() + num
        );
        vm.year = new Date(date);
        vm.bindQuery();
      } else {
        let difference =
          new Date(vm.timeInterval[1]).getTime() -
          new Date(vm.timeInterval[0]).getTime();
        let start = new Date(vm.timeInterval[0]).setTime(
          new Date(vm.timeInterval[0]).getTime() + num * difference
        );
        let end = new Date(vm.timeInterval[1]).setTime(
          new Date(vm.timeInterval[1]).getTime() + num * difference
        );
        vm.timeInterval = [new Date(start), new Date(end)];
        vm.bindQuery();
      }
    },
  },
};
</script>

<style lang="scss">
@page {
  //   size: auto; /* auto is the initial value */
  //   margin: 0mm; /* this affects the margin in the printer settings */
  size: 10cm 25cm; /* auto is the initial value */
  margin: 0; /* this affects the margin in the printer settings */
}
.time-warp {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  display: flex;
  .el-input__inner,
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
  .el-range-separator {
    line-height: 22px;
  }
  .item {
    margin-left: 10px;
  }
}
</style>

<style lang="scss" scoped>
.primary >>> .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}
::v-deep .el-button--primary {
  background-color: #0080ff;
  background: #0080ff;
  border-color: #0080ff;
}
</style>
